// extracted by mini-css-extract-plugin
export default {"container":"tA-z","modal":"uA-z","dimensions":"vA-z","brandName":"wA-z","productName":"xA-z","labelValue":"yA-z","recipientEmail":"zA-z","recommendedFit":"AA-z","hiddenField":"BA-z"};